import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { TranslationService } from '@shared/services/translation/translation.service';

@Pipe({
  name: 'chipsList'
})
export class ChipsListPipe implements PipeTransform {
  constructor(
    private translation: TranslateService,
    private translationService: TranslationService
  ) { }

  // Use i18n currently loaded translation, since translations cannot be localized
  public currentLang = this.translation.currentLang;

  public transform(tags: any[], lang?: any, selectedTags?: any): any {
    let options = [];
    if (lang) {
      this.currentLang = lang;
    }
    tags.forEach(tag => {
      if (tag.translations) {
        options.push({
          value: tag.id,
          translations: tag.translations,
          display: this.translationService.getTranslationValue(tag.translations, this.currentLang)
        });
      }
    });
    if (selectedTags && selectedTags.length) {
      options = options.filter(el => selectedTags.some(x => x.value !== el.value));
    }
    return options;
  }

}
